import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { ContextService } from "../context-service";
import { UserAutoSaveSearch } from '@apply4u/models/user-save-search/user-auto-save-search';
import { IsNotNull, IsNotNullOrEmpty, IsNotZero } from "@apply4u/shared/helpers/common/type-safe-helpers";
import { SearchParams } from '@apply4u/models/search/search-params';
import { AutoSearchService } from '@apply4u/services/data-services/auto-search.service';
import { ToasterMessageService } from '@apply4u/services/toaster-message.service';
import { SearchService } from '@apply4u/services/search/search.service';

@Injectable({
  providedIn: 'root'
})
export class AdvanceSearchService {
  AutoSaveSearch = new UserAutoSaveSearch();
  SearchParams: SearchParams;

  constructor(
    private router: Router,
    private contextService: ContextService,
    private toasterService: ToasterMessageService,
    private autoSaveSearchService: AutoSearchService,
    private searchService: SearchService) { }

  ngOnInit(): void {
  }

  CreateAutoSaveSearch(searchParams: SearchParams): void {
    if (IsNotNull(searchParams)) {
      this.SearchParams = searchParams;
      this.InitializeSaveSearch();
      if (IsNotNullOrEmpty(this.AutoSaveSearch.KeyWords)) {
        this.autoSaveSearchService.CreateConfirmAutoSaveSearchhandler(this.AutoSaveSearch);
      } else {
        this.toasterService.Error('Keywords can not be empty', null);
      }
    }
  }

  InitializeSaveSearch() {
    if (IsNotNull(this.SearchParams)) {
      this.AutoSaveSearch.KeyWords = this.SearchParams.Keywords;
      this.AutoSaveSearch.AllofTheseWords = this.SearchParams.AllofTheseWords;
      this.AutoSaveSearch.ExactPharse = this.SearchParams.ExactPhrae;
      this.AutoSaveSearch.AnyofTheseWords = this.SearchParams.AnyOfTheseWords;
      this.AutoSaveSearch.NoneofTheseWords = this.SearchParams.NoneOfTheseWords;
      this.AutoSaveSearch.LocationText = this.SearchParams.Location;

      if (IsNotZero(this.SearchParams.SalaryDuration)) {
        this.AutoSaveSearch.SalaryDurationId = this.SearchParams.SalaryDuration;
      } else {
        this.AutoSaveSearch.SalaryDurationId = 5// default;
      }
      this.AutoSaveSearch.SalaryFrom = this.SearchParams.SalaryFrom;
      this.AutoSaveSearch.SalaryTo = this.SearchParams.SalaryTo;
      this.AutoSaveSearch.JobTypeIds = this.SearchParams.JobTypes;
      this.AutoSaveSearch.JobCategoryIds = this.SearchParams.JobStatus;
      this.AutoSaveSearch.PositionTypeIds = this.SearchParams.PositionTypes;
      this.AutoSaveSearch.CandidateTypeIds = this.SearchParams.ProfileTypes;
      this.AutoSaveSearch.SearchWithInLast = this.SearchParams.SearchWithIn;
      this.AutoSaveSearch.Radius = this.SearchParams.Radius;
      this.AutoSaveSearch.IsSearchInTitle = this.SearchParams.SearchInJobTitle;
      this.AutoSaveSearch.IsFilterApplyed = this.SearchParams.IsFilterSearch;
      this.AutoSaveSearch.IsSearchByLocation = this.SearchParams.IsSearchByLocation;
      this.AutoSaveSearch.IsSearchByIndustry = this.SearchParams.IsSearchBySector;
      this.AutoSaveSearch.UserId = this.contextService.LoggedInUserId;
      this.AutoSaveSearch.SavedSearchTypeId = 2;
      this.AutoSaveSearch.IsBroadMatch = false;
      this.AutoSaveSearch.CreatedOn = new Date();
      this.AutoSaveSearch.IsActive = false;
      this.AutoSaveSearch.IsDefault = false;
      this.AutoSaveSearch.EmailFrequencyId = null;

      if (IsNotNullOrEmpty(this.AutoSaveSearch.JobTypeIds)) {
        this.AutoSaveSearch.JobTypeIds = this.AutoSaveSearch.JobTypeIds.replace(/,/g, '|');
      }

      if (IsNotNullOrEmpty(this.AutoSaveSearch.JobCategoryIds)) {
        this.AutoSaveSearch.JobCategoryIds = this.AutoSaveSearch.JobCategoryIds.replace(/,/g, '|');
      }

      if (IsNotNullOrEmpty(this.AutoSaveSearch.PositionTypeIds)) {
        this.AutoSaveSearch.PositionTypeIds = this.AutoSaveSearch.PositionTypeIds.replace(/,/g, '|');
      }

      if (IsNotNullOrEmpty(this.AutoSaveSearch.CandidateTypeIds)) {
        this.AutoSaveSearch.CandidateTypeIds = this.AutoSaveSearch.CandidateTypeIds.replace(/,/g, '|');
      }

      if (this.contextService.IsJobSeeker) {
        this.AutoSaveSearch.IsJobSearch = true;
        this.AutoSaveSearch.IsCvSearch = false;
      } else {
        this.AutoSaveSearch.IsCvSearch = true;
        this.AutoSaveSearch.IsJobSearch = false;
      }
    }
  }

  OnClickConfirmSaveSearchModal(): void {
    this.OnCloseConfirmSaveSearchModal();
    let listPageUrl = "/my-auto-searches";
    this.router.navigateByUrl(listPageUrl);
  }

  OnCloseConfirmSaveSearchModal(): void {
    let element = document.getElementById('CloseSaveSearchConfirmModal');
    if (IsNotNull(element)) {
      element.click();
    }
  }

  AdvanceSearchHandler(searchParams: SearchParams) {
    const isAdvanceSearch = true;
    searchParams.IsSimpleSearch = true;
    searchParams.IsBooleanSearch = true;
    searchParams.IsBoolean = false;   
    this.SearchParams = searchParams;
    
    if (this.contextService.IsJobSeeker) {
      this.router.navigateByUrl(this.searchService.GetJobSearchUrl(isAdvanceSearch));
    } else {
      this.router.navigateByUrl(this.searchService.GetCVSearchUrl(this.SearchParams,isAdvanceSearch));
    }
  }


}
